export const initialFiltersQuery = `
query InitialFilters(
$termCriteria:ConfigurationCriteria
$customerGroupCriteria:ConfigurationCriteria
$productCollectionCriteria:ConfigurationCriteria
$modalityCriteria:ConfigurationCriteria
$productCriteria:ConfigurationCriteria
){
  customerGroupFilters: filters(criteria: $customerGroupCriteria) {
    customerGroups {
      __typename
      id
      deeplinkId
      title
      nrOfProductConfigurations
      isDefault
      order
    }
  }
  productCollectionFilters: filters(criteria: $productCollectionCriteria) {
    productCollections {
      __typename
      id
      deeplinkId
      title
      nrOfProductConfigurations
      intro
      description
      order
    }
  }
  modalityFilters: filters(criteria: $modalityCriteria) {
    modalities {
      __typename
      id
      deeplinkId
      title
      nrOfProductConfigurations
    }
  }
  productFilters: filters(criteria: $productCriteria) {
    products {
      __typename
      id
      deeplinkId
      title
      nrOfProductConfigurations
      intro
      termsLink
      description
      order
      hasCombiDeals
      collection {
        id
      }
      modalities {
        id
        title
      }
    }
  },
  termFilters: filters(criteria: $termCriteria) {
    terms {
      __typename
      id
      deeplinkId
      title
      nrOfProductConfigurations
      termsPerYear
    }
  }
}
`



// WEBPACK FOOTER //
// ./src/products-api/queries/initial-filters.js